// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5639":"258ac5a0a67f04d2","5957":"71ce681bf48a93a9"}[chunkId] + ".css";
};